import { postApiRequest } from './_tools';

export function updateAccount(data) {
  return postApiRequest('/api/profile', data)
    .catch(({ error }) => Promise.reject(error));
}

export function updatePassword({ oldPassword, newPassword }) {
  return postApiRequest('/api/profile/password', { oldPassword, newPassword })
    .catch(({ error }) => Promise.reject(error));
}

export function updatePublisherCompanyInfo(data) {
  return postApiRequest('/api/profile/company', data)
    .catch(({ error }) => Promise.reject(error));
}

export function updatePaymentInfo(data) {
  return postApiRequest('/api/profile/paymentInfo', data)
    .catch(({ error }) => Promise.reject(error));
}



/** WEBPACK FOOTER **
 ** ./js/core/api/profile.js
 **/